export type Maybe<T> = T | null
export type InputMaybe<T> = Maybe<T>
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] }
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> }
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> }
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never }
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never }
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string }
  String: { input: string; output: string }
  Boolean: { input: boolean; output: boolean }
  Int: { input: number; output: number }
  Float: { input: number; output: number }
  DateTime: { input: any; output: any }
  JSON: { input: any; output: any }
  Upload: { input: any; output: any }
}

export type AiPodcastResponse = {
  __typename?: 'AIPodcastResponse'
  fileName?: Maybe<Scalars['String']['output']>
  url?: Maybe<Scalars['String']['output']>
}

export type Buttons = {
  __typename?: 'Buttons'
  audio?: Maybe<ButtonsAudio>
  createOverview?: Maybe<Scalars['String']['output']>
  playPodcast?: Maybe<Scalars['String']['output']>
  relatedModels?: Maybe<Scalars['String']['output']>
}

export type ButtonsAudio = {
  __typename?: 'ButtonsAudio'
  recordingYourVoice?: Maybe<Scalars['String']['output']>
}

export type CategoriesTranslateInput = {
  languageEnum?: LanguageEnum
}

export enum CategoryIdEnum {
  All = 'ALL',
  Bim = 'BIM',
  Career = 'CAREER',
  Company = 'COMPANY',
  Design = 'DESIGN',
  DownloadsModels = 'DOWNLOADS_MODELS',
  DownloadsTrialVersions = 'DOWNLOADS_TRIAL_VERSIONS',
  Education = 'EDUCATION',
  General = 'GENERAL',
  KnowledgeAnalysisAndCalculation = 'KNOWLEDGE_ANALYSIS_AND_CALCULATION',
  KnowledgeBasicsOfSoftware = 'KNOWLEDGE_BASICS_OF_SOFTWARE',
  KnowledgeBestPracticesAndTips = 'KNOWLEDGE_BEST_PRACTICES_AND_TIPS',
  KnowledgeInstallationAndSetup = 'KNOWLEDGE_INSTALLATION_AND_SETUP',
  KnowledgeModelingAndDesign = 'KNOWLEDGE_MODELING_AND_DESIGN',
  KnowledgeResultsAndReporting = 'KNOWLEDGE_RESULTS_AND_REPORTING',
  KnowledgeTechnicalTerms = 'KNOWLEDGE_TECHNICAL_TERMS',
  KnowledgeUserInterface = 'KNOWLEDGE_USER_INTERFACE',
  Others = 'OTHERS',
  ProductsAddOn = 'PRODUCTS_ADD_ON',
  ProductsMainProgram = 'PRODUCTS_MAIN_PROGRAM',
  Sales = 'SALES',
  SolutionsBimAndInterfaces = 'SOLUTIONS_BIM_AND_INTERFACES',
  SolutionsCrossSections = 'SOLUTIONS_CROSS_SECTIONS',
  SolutionsDynamicAnalysis = 'SOLUTIONS_DYNAMIC_ANALYSIS',
  SolutionsMasonryStructures = 'SOLUTIONS_MASONRY_STRUCTURES',
  SolutionsReinforcedConcreteStructures = 'SOLUTIONS_REINFORCED_CONCRETE_STRUCTURES',
  SolutionsSteelJoints = 'SOLUTIONS_STEEL_JOINTS',
  SolutionsSteelStructures = 'SOLUTIONS_STEEL_STRUCTURES',
  SolutionsTimberStructures = 'SOLUTIONS_TIMBER_STRUCTURES',
  SolutionsWindSimulation = 'SOLUTIONS_WIND_SIMULATION',
  SupportTroubleshooting = 'SUPPORT_TROUBLESHOOTING',
  TrainingAndResources = 'TRAINING_AND_RESOURCES'
}

export type CategoryTranslate = {
  __typename?: 'CategoryTranslate'
  categoryEnumType: CategoryIdEnum
  id: Scalars['Int']['output']
  ngChatPromptCategory?: Maybe<Scalars['String']['output']>
  ngColor?: Maybe<Scalars['String']['output']>
  ngCreatedBy?: Maybe<Scalars['String']['output']>
  ngCreatedOn?: Maybe<Scalars['DateTime']['output']>
  ngModifiedBy?: Maybe<Scalars['String']['output']>
  ngModifiedOn?: Maybe<Scalars['DateTime']['output']>
  ngProjectId?: Maybe<Scalars['Int']['output']>
  ngSequence?: Maybe<Scalars['Int']['output']>
  ngSourceLanguage?: Maybe<Scalars['String']['output']>
  pform?: Maybe<Scalars['Int']['output']>
  pid?: Maybe<Scalars['Int']['output']>
  system?: Maybe<Scalars['String']['output']>
  userid?: Maybe<Scalars['Int']['output']>
}

export type ChatPromptTranslate = {
  __typename?: 'ChatPromptTranslate'
  id: Scalars['Int']['output']
  ngChatPrompt?: Maybe<Scalars['String']['output']>
  ngChatPromptCategory?: Maybe<Scalars['String']['output']>
  ngChatPromptCategoryId?: Maybe<Scalars['Int']['output']>
  ngCreatedBy?: Maybe<Scalars['String']['output']>
  ngCreatedOn?: Maybe<Scalars['DateTime']['output']>
  ngDeleted?: Maybe<Scalars['String']['output']>
  ngLanguage?: Maybe<Scalars['String']['output']>
  ngModifiedBy?: Maybe<Scalars['String']['output']>
  ngModifiedOn?: Maybe<Scalars['DateTime']['output']>
  ngPublished?: Maybe<Scalars['String']['output']>
  ngSequence?: Maybe<Scalars['Int']['output']>
  ngTransferTimestamp?: Maybe<Scalars['DateTime']['output']>
  pform?: Maybe<Scalars['Int']['output']>
  pid?: Maybe<Scalars['Int']['output']>
  system?: Maybe<Scalars['String']['output']>
  userid?: Maybe<Scalars['Int']['output']>
}

export type ChatPromptTranslateInput = {
  blockSize?: Scalars['Int']['input']
  categoryId?: CategoryIdEnum
  languageEnum?: LanguageEnum
  offset?: Scalars['Int']['input']
}

export type Citations = {
  __typename?: 'Citations'
  sources?: Maybe<Scalars['String']['output']>
}

export type Controls = {
  __typename?: 'Controls'
  audio?: Maybe<ControlsAudio>
  badResponse?: Maybe<Scalars['String']['output']>
  copy?: Maybe<Scalars['String']['output']>
  editMessage?: Maybe<Scalars['String']['output']>
  goodResponse?: Maybe<Scalars['String']['output']>
  newConversation?: Maybe<Scalars['String']['output']>
  scrollToBottom?: Maybe<Scalars['String']['output']>
  sendMessage?: Maybe<Scalars['String']['output']>
}

export type ControlsAudio = {
  __typename?: 'ControlsAudio'
  next?: Maybe<Scalars['String']['output']>
  play?: Maybe<Scalars['String']['output']>
  prev?: Maybe<Scalars['String']['output']>
  startRecording?: Maybe<Scalars['String']['output']>
  stopRecording?: Maybe<Scalars['String']['output']>
  volume?: Maybe<Scalars['String']['output']>
}

export type Errors = {
  __typename?: 'Errors'
  noSettingsData?: Maybe<Scalars['String']['output']>
}

export enum LanguageEnum {
  Cs = 'CS',
  De = 'DE',
  En = 'EN',
  EnUs = 'EN_US',
  Es = 'ES',
  Fr = 'FR',
  It = 'IT',
  Pl = 'PL',
  Pt = 'PT',
  Ru = 'RU',
  Zh = 'ZH'
}

export type LocalizationTextInput = {
  languageEnum?: LanguageEnum
}

export type Mutation = {
  __typename?: 'Mutation'
  transcribeWholeAudio: Scalars['String']['output']
}

export type MutationTranscribeWholeAudioArgs = {
  audio: Scalars['Upload']['input']
}

export type PageInfo = {
  __typename?: 'PageInfo'
  endOffset: Scalars['Int']['output']
  hasNextPage: Scalars['Boolean']['output']
  hasPreviousPage: Scalars['Boolean']['output']
  startOffset: Scalars['Int']['output']
  totalItems: Scalars['Int']['output']
}

export type Placeholder = {
  __typename?: 'Placeholder'
  chatTitle?: Maybe<Scalars['String']['output']>
  defaultMessage?: Maybe<Scalars['String']['output']>
  welcomeMessage?: Maybe<Scalars['String']['output']>
}

export type Podcasts = {
  __typename?: 'Podcasts'
  morePodcasts?: Maybe<Scalars['String']['output']>
}

export type Query = {
  __typename?: 'Query'
  readCategoriesTranslate: ReadCategoriesTranslateType
  readChatLocalizationText: ReadChatLocalizationTextType
  readChatLocalizationTextJson: Scalars['JSON']['output']
  readChatPromptTranslate: ReadChatPromptTranslateType
  readNgAipodcastUrl: AiPodcastResponse
}

export type QueryReadCategoriesTranslateArgs = {
  categoriesTranslateInput: CategoriesTranslateInput
}

export type QueryReadChatLocalizationTextArgs = {
  localizationTextInput: LocalizationTextInput
}

export type QueryReadChatLocalizationTextJsonArgs = {
  localizationTextInput: LocalizationTextInput
}

export type QueryReadChatPromptTranslateArgs = {
  chatPromptTranslateInput: ChatPromptTranslateInput
}

export type QueryReadNgAipodcastUrlArgs = {
  languageEnum: LanguageEnum
  podcastId: Scalars['Int']['input']
}

export type ReadCategoriesTranslateType = {
  __typename?: 'ReadCategoriesTranslateType'
  data?: Maybe<Array<CategoryTranslate>>
  error?: Maybe<ReadError>
}

export type ReadChatLocalizationTextType = {
  __typename?: 'ReadChatLocalizationTextType'
  buttons?: Maybe<Buttons>
  citations?: Maybe<Citations>
  controls?: Maybe<Controls>
  error?: Maybe<ReadError>
  errors?: Maybe<Errors>
  hangInThere?: Maybe<Scalars['String']['output']>
  placeholder?: Maybe<Placeholder>
  podcasts?: Maybe<Podcasts>
}

export type ReadChatPromptTranslateType = {
  __typename?: 'ReadChatPromptTranslateType'
  data?: Maybe<Array<ChatPromptTranslate>>
  error?: Maybe<ReadError>
  pageInfo?: Maybe<PageInfo>
}

export type ReadError = {
  __typename?: 'ReadError'
  message: Scalars['String']['output']
}

export type Subscription = {
  __typename?: 'Subscription'
  getSummaryForUrl: Scalars['String']['output']
  getSummaryWithText: Scalars['String']['output']
}

export type SubscriptionGetSummaryForUrlArgs = {
  url: Scalars['String']['input']
}

export type SubscriptionGetSummaryWithTextArgs = {
  text: Scalars['String']['input']
}
